export const ENVELOPE_SOFTWARE_ID_MANTY_STATUS = 'envelope_manty_status';
export const ENVELOPE_SOFTWARE_ID_PAY_COMPONENT = 'envelope_pay_component';
